import Companies from '@clearkit/icons/glyphs/Companies';
import Facebook from '@clearkit/icons/glyphs/Facebook';
import GitHub from '@clearkit/icons/glyphs/Github';
import Linkedin from '@clearkit/icons/glyphs/Linkedin';
import Twitter from '@clearkit/icons/glyphs/Twitter';

import Group from './Group';

const PersonEnrichment = ({ person, enrichment, search }) => {
  const valueForAttribute = (attribute) =>
    enrichment?.find(({ label }) => label === attribute)?.value;
  const attribute = (label) => ({ label, value: valueForAttribute(label) });

  return (
    <>
      <Group
        search={search}
        title="Person"
        icon={Companies}
        sections={[
          [
            attribute('Full Name'),
            { label: 'Email', value: person.email },
            [attribute('Given Name'), attribute('Family Name')],
          ],
          [attribute('Site'), attribute('Avatar')],
          [attribute('Bio')],
        ]}
      />
      <Group
        search={search}
        title="Twitter"
        type={'twitter'}
        icon={Twitter}
        sections={[
          [
            'Twitter Handle',
            'Twitter Id',
            'Twitter Followers',
            'Twitter Following',
          ].map(attribute),
        ]}
      />
      <Group
        search={search}
        title="Facebook"
        type={'facebook'}
        icon={Facebook}
        sections={[['Facebook Handle'].map(attribute)]}
      />
      <Group
        search={search}
        title="Linkedin"
        type={'linkedin'}
        icon={Linkedin}
        sections={[['Linkedin Handle'].map(attribute)]}
      />
      <Group
        search={search}
        title="GitHub"
        type={'github'}
        icon={GitHub}
        sections={[['GitHub Handle', 'GitHub Followers'].map(attribute)]}
      />
    </>
  );
};

PersonEnrichment.propTypes = {
  enrichment: PropTypes.array,
  search: PropTypes.string,
  person: PropTypes.shape({
    email: PropTypes.string,
  }),
};

export default PersonEnrichment;
